import React from 'react';
import T from 'prop-types';
import queryString from 'qs';
import { Link } from 'react-router-dom';
import * as utils from '../findcare-map/helpers';

const SortLink = (props) => {
  if (props.s === props.type) return <li>{props.children}</li>;

  const query = {
    ...props.query,
    s: props.type,
  };

  if (props.coords && !query.g) {
    query.lat = props.coords.latitude;
    query.lng = props.coords.longitude;
  }

  query.heading = utils.sanitizeHeading(props.heading);

  return (
    <li>
      <Link to={`?${queryString.stringify(query)}`}>{props.children}</Link>
    </li>
  );
};

SortLink.propTypes = {
  heading: T.string,
  children: T.node,
  type: T.string,
  s: T.string,
  query: T.object,
  coords: T.shape({
    latitude: T.number,
    longitude: T.number,
  }),
};

export default SortLink;
